export default "__VITE_ASSET__BUQSinul__"